"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EducationSection = void 0;
const react_1 = __importStar(require("react"));
const WebformFieldRouter_1 = require("../WebformFieldRouter");
const EducationSection = ({ section, data, errors, onChange, disabled, lookups, }) => {
    const educationData = data.education || [{}];
    const updateRow = (0, react_1.useCallback)((rowIdx, field, value) => {
        const updated = [...educationData];
        if (!updated[rowIdx])
            updated[rowIdx] = {};
        updated[rowIdx][field] = value;
        onChange('education', updated);
    }, [educationData, onChange]);
    const addRow = (0, react_1.useCallback)(() => {
        onChange('education', [...educationData, {}]);
    }, [educationData, onChange]);
    const removeRow = (0, react_1.useCallback)((idx) => {
        onChange('education', educationData.filter((_, i) => i !== idx));
    }, [educationData, onChange]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        educationData.map((row, idx) => (react_1.default.createElement("div", { key: idx, className: "repeatable-row" },
            react_1.default.createElement("div", { className: "repeatable-row-header" },
                react_1.default.createElement("div", { className: "repeatable-row-title" },
                    "Qualification ",
                    idx + 1),
                educationData.length > 1 && (react_1.default.createElement("button", { type: "button", className: "wf-btn-remove", onClick: () => removeRow(idx), disabled: disabled }, "Remove"))),
            react_1.default.createElement("div", { className: "form-row" }, (section.fields || []).map((field) => (react_1.default.createElement("div", { key: field.key },
                react_1.default.createElement(WebformFieldRouter_1.WebformFieldRouter, { field: {
                        key: `edu_${idx}_${field.key}`,
                        label: field.label,
                        type: field.type || 'text',
                        required: field.required,
                        lookup: field.lookup,
                    }, value: row[field.key] || '', onChange: (_key, val) => updateRow(idx, field.key, val), error: errors[`education.${idx}.${field.key}`], disabled: disabled, lookups: lookups })))))))),
        react_1.default.createElement("button", { type: "button", className: "wf-btn-add", onClick: addRow, disabled: disabled }, "+ Add Qualification")));
};
exports.EducationSection = EducationSection;
